import { render, staticRenderFns } from "./VantagensOutros.vue?vue&type=template&id=066e76fa&"
import script from "./VantagensOutros.js?vue&type=script&lang=js&"
export * from "./VantagensOutros.js?vue&type=script&lang=js&"
import style0 from "./VantagensOutros.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
